export default __webpack_public_path__ + "static/media/NextIcon.2076b4b0.svg";